import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { i18n } from '../../../../symphony';

import s from './StreakGoalOption.scss';

interface IStreakGoalOptionData {
    text: string;
    daysAmount: number;
    selected: boolean;
    onClick: () => void;
}

export const StreakGoalOption: React.FC<IStreakGoalOptionData> = React.memo(
	({
		text, selected, onClick, daysAmount,
	}) => {
		useStyles(s);
		return (
			<div
				className={`streak-goal-option ${selected ? ' selected' : ''}`}
				sl-test-data={`cmpStreakGoalOption-${text}`}
				onClick={onClick}
			>
				{i18n.t(`streak.option-${daysAmount}.text`)}
			</div>
		);
	},
);
